import { render, staticRenderFns } from "./ZyroCollapsible.vue?vue&type=template&id=5c8750d6&scoped=true&"
import script from "./ZyroCollapsible.vue?vue&type=script&lang=js&"
export * from "./ZyroCollapsible.vue?vue&type=script&lang=js&"
import style0 from "./ZyroCollapsible.vue?vue&type=style&index=0&id=5c8750d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8750d6",
  null
  
)

export default component.exports